import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import { useLazyGetFieldsValueQuery, useGetVendorHeaderListQuery } from "../../utils/customer/customerSelect";
import { getPath } from "../../utils/utilityFunctions/stringUtility";
import DynamicVoucher from "./DynamicVoucher";
import LayoutHOC from "../LayoutHOC";
import VendorDashboard from "./VendorDashboard";
const VendorDynamicPage = ({}) => {
  const navigate = useNavigate();
  const { subRoute } = useParams();
  const { token } = useRequireAuth();
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");

  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const companyId = storedData ? JSON.parse(storedData) : null;

  const { data: vendorHeaderData } = useGetVendorHeaderListQuery({
    tokens,
    companyId,
  });
  const [selectedHeader, setSelectedHeader] = useState({});

  // const [getFieldsValue, { data: formConfig }] = useLazyGetFieldsValueQuery();

  // // useEffect(() => {
  // //   if(vendorHeaderData && subRoute)
  // //   setSelectedHeader(vendorHeaderData?.find((option) => option?.name === subRoute) || {});
  // // }, [subRoute,vendorHeaderData]);

  // useEffect(() => {
  //   if (selectedHeader?.id)
  //     getFieldsValue({
  //       tokens,
  //       voucherId: selectedHeader?.id,
  //     });
  // }, [selectedHeader?.id]);

  useEffect(() => {
    if (vendorHeaderData) {
      const requiredVoucher =
        vendorHeaderData?.find((option) => option?.name?.toLowerCase() === subRoute?.toLowerCase()) || 0;
      setSelectedHeader(requiredVoucher);
    }
  }, [vendorHeaderData]);

  const handleClick = (index, option) => {
    setSelectedHeader(option);
    navigate(`/vendor/${option.name}`);
  };

  return (
    <div className="px-4 py-2">
      <div className="mb-3 sm:mt-5 px-3 sm:pl-5 border border-[#D6D3D3] bg-white items-center rounded ">
        <ul className="flex flex-wrap z-10 text-16 sm:text-16 sm:pt-1 sm:gap-4 md:gap-8 ">
          {vendorHeaderData?.map((option, index) => (
            <li
              key={option}
              onClick={() => handleClick(index, option)}
              className={`cursor-pointer py-1 ${
                selectedHeader?.id === option?.id
                  ? "text-[#203C50] font-500 border-b border-[#203C50]"
                  : "text-[#848687] font-400"
              }`}
            >
              {option.name}
            </li>
          ))}
        </ul>
      </div>
      {/* {formConfig && <DynamicVoucher formConfig={formConfig?.data} voucher={selectedHeader} />} */}
      <VendorDashboard voucher={selectedHeader} tokens={tokens} />
    </div>
  );
};

export default LayoutHOC(VendorDynamicPage);
